import { darkColors, createThermalGradient } from './colors';
import { fontFamily, fontSize, fontWeight, lineHeight, letterSpacing, typography } from './typography';
import { breakpoints, media, container, spacing } from './breakpoints';
import { duration, easing, keyframes, animations, transitions } from './animations';

// Base theme with all shared properties
const baseTheme = {
  fontFamily,
  fontSize,
  fontWeight,
  lineHeight,
  letterSpacing,
  typography,
  breakpoints,
  media,
  container,
  spacing,
  duration,
  easing,
  keyframes,
  animations,
  transitions,
  createThermalGradient,
};

// Dark theme
export const darkTheme = {
  ...baseTheme,
  name: 'dark',
  colors: darkColors,
};

// Default theme
export const defaultTheme = darkTheme;

export { darkColors, createThermalGradient };
export { fontFamily, fontSize, fontWeight, lineHeight, letterSpacing, typography };
export { breakpoints, media, container, spacing };
export { duration, easing, keyframes, animations, transitions };